import { slotsToLabel, syncLegacyPresetFromSlots, uiSlotCodeLabel } from '../../data/specialtyMealPlans';
import { collectActiveDeliveryWeekdays } from '../../utils/subscriptionDisplay';

const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const PRIMARY_MEAL_SLOTS = ['breakfast', 'lunch', 'dinner'];

export const BUILDER_SCHEDULE_ID = 'individual_by_item';
export const BUILDER_SCHEDULE_LABEL = 'Custom per item & slot';

export function collectItemScheduleDays(itemScheduleRows = [], { startDate, endDate } = {}) {
  if (startDate && endDate) {
    return collectActiveDeliveryWeekdays({ startDate, endDate, itemScheduleRows });
  }
  const days = new Set();
  itemScheduleRows.forEach((row) => {
    (row.days || []).forEach((day) => days.add(day));
  });
  return DAY_ORDER.filter((day) => days.has(day));
}

export function formatDayList(days = [], style = 'short') {
  if (!days.length) return '';
  if (style === 'full') return days.join(', ');
  return days.map((day) => day.slice(0, 3)).join(', ');
}

export function buildBuilderMealLabel(itemScheduleRows = [], uiSlotCodes = []) {
  const slotIds = new Set(
    (itemScheduleRows || [])
      .map((row) => String(row?.slotId || '').trim().toLowerCase())
      .filter((slotId) => slotId && slotId !== 'full_day'),
  );
  if (slotIds.size) {
    const ordered = PRIMARY_MEAL_SLOTS.filter((slotId) => slotIds.has(slotId));
    const extras = [...slotIds].filter((slotId) => !PRIMARY_MEAL_SLOTS.includes(slotId));
    const labels = [...ordered, ...extras].map((slotId) => uiSlotCodeLabel(slotId));
    return labels.length ? labels.join(' + ') : 'No meal slots selected';
  }
  if (!uiSlotCodes.length) return 'No meal slots selected';
  return uiSlotCodes
    .map((code) => uiSlotCodeLabel(code))
    .join(' + ');
}

export function buildBuilderSubscriptionMeta({
  selectedBuilderSlotIds = [],
  itemScheduleRows = [],
  startDate = '',
  endDate = '',
} = {}) {
  const mealSlots = selectedBuilderSlotIds || [];
  const legacyPreset = syncLegacyPresetFromSlots(mealSlots);
  const days = collectItemScheduleDays(itemScheduleRows, { startDate, endDate });

  return {
    mealSlots,
    mealLabel: buildBuilderMealLabel(itemScheduleRows, mealSlots) || slotsToLabel(mealSlots) || 'No meal slots selected',
    mealType: legacyPreset || (mealSlots.length === 1 ? mealSlots[0] : 'multi_slot'),
    scheduleId: BUILDER_SCHEDULE_ID,
    scheduleLabel: BUILDER_SCHEDULE_LABEL,
    days,
  };
}

export function isBuilderSubscriptionPayload(payload = {}) {
  return payload.scheduleId === BUILDER_SCHEDULE_ID
    || (Array.isArray(payload.itemSchedules) && payload.itemSchedules.length > 0);
}
